import { Button, Col, Form, Input, InputPicker } from 'rsuite';
import TextField from '../../../components/form/textfield';
import { useCallback, useRef, useState } from 'react';
import { FlexboxGrid } from 'rsuite';
import Field from '../../../components/form/field';
import TextAreaField from '../../../components/form/textarea-field';
import { showToast } from '../../../utils/toast';
import { handlePostConsultantConsultationBackground } from '../../../api-handler';
import {
  PostConsultantConsultationBackgroundModel,
  defaultConsultantConsultationBackgroundFormValue,
  defaultConsultantConsultationBackgroundSchema
} from '../../../models';
import { getRandomId } from '../../../utils/helpers';
import { useNavigate } from 'react-router-dom';

export const ConsultationBackgroundForm = (props: {
  currentDoing: boolean;
  readonly?: boolean;
  handleAddDoingData: (
    newData: PostConsultantConsultationBackgroundModel,
    isCurrent: boolean
  ) => void;
  defaultValue?: PostConsultantConsultationBackgroundModel | null;
  hideNextButton?: boolean;
  forceReadOnly?: boolean;
  disabledMode?: boolean;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>(
    props.defaultValue ?? defaultConsultantConsultationBackgroundFormValue
  );

  const handleSubmit = useCallback(
    async (isNext: boolean) => {
      if (formRef.current && !formRef.current.check()) {
        console.log('formError', formError);
        return;
      }

      if (!formValue) return;
      const payload = {
        ...formValue
      };
      console.log(payload);
      setLoading(true);
      const res = await handlePostConsultantConsultationBackground(payload);
      setLoading(false);
      if (res.ok) {
        showToast('فرم ثبت شد!', 'success');
        // or getting submitted data from backend
        if (isNext) {
          navigate('/consultant/social');
          return;
        }
        props.handleAddDoingData({ ...payload, RandomId: getRandomId() }, props.currentDoing);
        setFormValue(defaultConsultantConsultationBackgroundFormValue);
      }
    },
    [formValue, formError, formRef, props.currentDoing]
  );

  return (
    <Form
      ref={formRef}
      onChange={setFormValue}
      onCheck={setFormError}
      formError={formError}
      model={defaultConsultantConsultationBackgroundSchema}
      onSubmit={() => handleSubmit(false)}
      formValue={formValue}
      checkTrigger="change"
      className="mt-6 text-dark"
      readOnly={props.forceReadOnly ?? loading}
      disabled={props.disabledMode}>
      <FlexboxGrid
        className={`${!props.currentDoing ? 'bg-[--rs-primary-50] rounded-md border-[1px] border-[--rs-primary-500] p-3' : null} `}>
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
          <FlexboxGrid>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%] !px-0">
              <Field
                accepter={InputPicker}
                data={[{ label: 'زمینه 1', value: 'زمینه 1' }]}
                name="Field"
                label="زمینه مشاوره"
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%] !px-0">
              <TextField
                name="NameCounselor"
                label={'نام و نام خانوادگی مشاوره گیرنده'}
                type="text"
                accepter={Input}
                dir="rtl"
                full
                placeholder=""
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>

            {/* todo: */}
          </FlexboxGrid>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
          <TextAreaField
            name="WorkedOn"
            label={'کار انجام شده'}
            dir="rtl"
            full
            req
            rows={5}
            placeholder=""
            readOnly={props.readonly}
          />
        </FlexboxGrid.Item>

        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
          <TextAreaField
            name="Result"
            label={'نتیجه'}
            dir="rtl"
            full
            req
            rows={5}
            placeholder=""
            readOnly={props.readonly}
          />
        </FlexboxGrid.Item>

        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
          <Field
            accepter={InputPicker}
            data={[{ label: 'مدت 1', value: 'مدت 1' }]}
            name="Period"
            label="مدت زمان فعالیت به عنوان مشاور"
            dir="rtl"
            full
            req
            readOnly={props.readonly}
          />
        </FlexboxGrid.Item>
      </FlexboxGrid>

      {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
      {props.readonly || props.disabledMode ? null : (
        <>
          <div className="flex justify-between">
            <Button
              appearance="primary"
              className="ml-auto mt-4"
              type="button"
              onClick={() => handleSubmit(false)}
              loading={loading}>
              {props.hideNextButton ? 'ثبت تحصیل فعلی' : 'افزودن سابقه جدید'}
            </Button>
          </div>
          {props.hideNextButton ? null : (
            <div className="flex justify-between">
              <Button
                appearance="default"
                className="ml-auto mt-8"
                type="button"
                onClick={() => {
                  navigate('/consultant/education');
                  // showToast('اطلاعات قبلا ثبت شده', 'warning');
                }}
                loading={loading}>
                مرحله قبل
              </Button>
              <Button
                appearance="primary"
                className="mr-auto mt-8"
                type="button"
                onClick={() => handleSubmit(true)}
                loading={loading}>
                مرحله بعد و ثبت
              </Button>
            </div>
          )}
        </>
      )}
    </Form>
  );
};
